module.exports = __webpack_public_path__ + "static/assets/3b7276c50e527adff1a3035b7ded515b.svg";